<template>
    <div class="Privacy">
        <menuBox :step="3"></menuBox>
        <div class="privacy-box">
             <div class="title">Privacy Policy</div>
             <img src="../assets/about-1.png" class="about">
             <div class="policy">
                 <div>Please read this policy carefully. By visiting this site, you acknowledge and agree to the practices described in this policy, except where your specific permission is required. This Privacy Policy and the legal notices on this website, which may be updated from time to time, describe how we collect, use and disclose personal and non-personal information collected through this website or in the course of our business activities. In accordance with applicable data protection laws, we will be responsible for controlling the personal information we collect from you on this website, or to conduct or develop our business with you. </div>
                 <strong>Information We Collect Automatically</strong>
                 <div>
                     When you visit this website, our servers automatically collect certain browser or device-generated information, including but not limited to:
                     <br> Domain name;
                     <br> IP address;
                     <br> The date, time and duration of your visit;
                     <br> ·Browser type;
                     <br> · Operating system;
                     <br> · Page visits.
                     <br> We will not use this automatically collected information to attempt to identify you, but we may associate it with information you voluntarily provide, as detailed below.
                     <strong>Information you provide</strong>
                     <div>
                         When using this website to do business with us or seek to do business with us, you may voluntarily provide us with personal information in the following ways:
                         <br> By completing a form (such as a "Contact Us" form) on our website or on an advertising landing page or anywhere else where we do business;
                         <br> By subscribing to newsletters or other information;
                         <br> Contact us by phone, email or our other contact methods;
                         <br> · Or through an application for a job, job placement or internship. the
                         <br> Generally, the personal information you provide to us may include name, company name, address, e-mail address, telephone number and any other personal information to resolve a query or complaint. This information will be required to enter into a contract with you (such as a service contract or purchase agreement or to provide services such as downloading information from our website). Failure to provide this information may result in us being unable to provide you with requested services or product requests. the
                     </div>
                     <strong>Use of Personal Information</strong>
                     <div>
                         The following outlines the purposes for which we use your personal information. Please note that additional details about how we process your personal information may be provided to you in a separate notice or contract. the
                         <br> All processing (ie use) of your personal information is subject to the Processing Conditions. In most cases, the grounds for lawful processing are:
                         <br> You have agreed to process;
                         <br> The steps to enter into a contract with you or enter into a contract require processing;
                         <br> We must process according to relevant laws; or
                         <br> · Based on our legitimate interests, in particular our legitimate interest in using supplier, customer and website user data to conduct and develop our business activities with them and others, without violating your interests and fundamental rights . the
                         <br> We use the personal information we collect to:
                         <br> Conduct and grow our business with you and others;
                         <br> Improve our website, and our products and services;
                         <br> Customize our website according to user needs;
                         <br> Provide you with the documents or information you request;
                         <br> Communicate with users to resolve their queries or complaints;
                         <br> Provide you with any services or products you request;
                         <br> Sending you marketing communications, if permitted. the
                         <br>
                         <br> Marketing, SMS and Email
                         <br> Under the premise of legality and your prior consent, we may contact you by text message and email to introduce our products and services to you. If you would like to unsubscribe from such marketing communications, please use the "unsubscribe" link provided in our emails, or contact us directly through the contact information indicated on the website, and we will stop sending you such communications.
                         <br> Analyzing for marketing purposes
                         <br> The purpose of the analysis is to provide you with website content or e-mail content that is highly relevant or applicable to your company. To do this, we use information provided by you and third parties for data enhancement services to try and identify your company's SIC industry code and other important information. In addition, we also try to identify products and applications that may be of interest to your company based on your visiting patterns on our website (information we collect automatically) and responses to our emails (information you provide). Based on this information, we will tailor email content and potentially website content to better match your company's requirements and interests. The processing described is based on our legitimate interests.
                         <br> security
                         <br> We use data storage and security technologies to protect your personal information from unauthorized access, misuse or disclosure, unauthorized modification or unlawful destruction or accidental loss. Please note, however, that no website can be guaranteed to be 100% secure and we cannot be held responsible for unauthorized or accidental access beyond our control.
                         <br> Keep your information
                         <br> We implement general rules for retaining personal information and we do not continue to retain personal information after the purpose for which it was collected has been fulfilled. However, in certain circumstances (such as legal, tax and accounting requirements), we may retain personal information for a longer period of time.
                         <br> In certain circumstances, we may also retain your personal information for longer periods of time so that we have an accurate record of your dealings with us in the event of a complaint or problem.
                         <br> Your rights
                         <br> Under applicable law, you may have some or all of the following rights related to your personal information:
                         <br> Obtain a copy of your personal information and information on how and on what basis it is processed;
                         <br> Correction of inaccurate personal information (including the right to complete incomplete personal information);
                         <br> Delete your personal information (in limited circumstances where it is no longer necessary for the purposes for which it was collected or processed);
                         <br> Restrict processing of your personal information in the following cases: 
                         <br> The accuracy of personal information is questioned;
                         <br> The processing is unlawful, but you object to the deletion of personal information;
                         <br> We no longer need the personal information, but we still need it to establish, exercise or defend legal claims;
                         <br> When we legally process your data with your consent or to perform a contract with you, store the data in a machine-readable format with a third party (or with you);
                         <br> Withdraw your consent to our processing of your personal information (where your consent is required for the processing);
                         <br> object to decisions based solely on automated processing or analysis;
                         <br> Obtain or view a copy of the appropriate safeguards in place for transfers of your personal information to third countries or international organisations.
                         <br> In addition to the above rights, you have the right to object to our processing of your information based on legitimate interests, including profiling (contrary to your consent, or for the purpose of entering into a contract with you). You also have the right to object to our processing of your information for direct marketing purposes, including profiling for marketing purposes. the
                         <br>
                         <br> You also have the right to lodge a data protection complaint with your local supervisory authority. the
                         <br> Regarding all these rights, please contact us using the "Contact Us" link at the top of the page. Please note that we may ask for identification and we reserve the right to charge a fee where permitted by law, for example if your request is manifestly unfounded or you are making an excessive request. We will endeavor to respond to your request within all applicable time frames. the
                         <br> Contact information
                         <br> If you have any questions about this policy or would like to exercise any of your rights, please click here to submit your request.

                     </div>
                 </div>
             </div>
         </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.Privacy {
    background: linear-gradient(90deg, #F7964F 0%, #F65A52 100%);
    text-align: center;

    // padding: 120px 390px;
    .privacy-box {
        padding: 120px 390px;
    }

    .title {
        font-size: 48px;
        font-weight: 500;
        color: #FFFFFF;
    }

    .about {
        margin-top: 10px;
        width: 160px;
    }

    .policy {
        width: 1060px;
        height: 666px;
        background: #FFFFFF;
        border-radius: 8px;
        overflow-y: scroll;
        margin-top: 60px;
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        text-align: left;
        padding: 40px;

        strong {
            padding-top: 20px;
            color: #333;
            display: block;
        }

    }
}
</style>
